const { Dispatcher } = require('flux');
const log = require('@gral/log')('DISPATCHER');

log.info('Creating dispatcher...');
module.exports = new Dispatcher();
